export default "__VITE_ASSET__DMCHXbf$__"